import clsx from 'clsx';
import { Switch } from 'ui';
import SkeletonDialogGoogleClassroomImportUsers from 'ui/shared/dialogs/DialogGoogleClassroomImportUsers/SkeletonDialogGoogleClassroomImportUsers';
import PropTypes from 'prop-types';
import React from 'react';
import GoogleClassroomStudentsList from '../GoogleClassroomStudentsList/GoogleClassroomStudentsList';

const GoogleClassroomItem = ({ loadingClass, selected, guid, name, students, onChangeSelected, onChangeSelectedStudents }) => {
  return (
    <li className={clsx('google-classroom-item', { 'google-classroom-item--selected': selected })}>
      <div className="google-classroom-item__classroom">
        <Switch onChange={() => onChangeSelected(guid, !selected)} checked={selected} label={name} />
      </div>
      {selected && (
        <div className="google-classroom-item__students">
          {loadingClass === guid ? (
            <SkeletonDialogGoogleClassroomImportUsers />
          ) : (
            <GoogleClassroomStudentsList classGuid={guid} students={students} legend={name} isLegendHidden onChangeSelected={onChangeSelectedStudents} />
          )}
        </div>
      )}
    </li>
  );
};

GoogleClassroomItem.propTypes = {
  guid: PropTypes.string,
  loadingClass: PropTypes.string,
  name: PropTypes.string,
  onChangeSelected: PropTypes.func,
  onChangeSelectedStudents: PropTypes.func,
  selected: PropTypes.bool,
  students: PropTypes.array,
};

GoogleClassroomItem.defaultProps = {
  selected: false,
  onChangeSelected: () => {},
};

export default GoogleClassroomItem;
